import setCurrentPage from "src/Utils/setCurrentPage";
import ConversationEffect from "src/Animations/ConversationEffect";

export const DATA_ND_DEMO_TCA_5 = {
  title: "Effortlessly view and manage \ninstances of network services",
  subtitle: "Network designer",
  text: "Effortless Control: list, instantiate, and terminate network \nservices with real-time visibility into orchestration workflow.",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ILO_311"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => {
      setCurrentPage("ILO_309");
    },
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/TCA/TCA_Demo_bg.jpg",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ILO/TCA/TCA_ND_Demo_5_Screen_1.png",
          imageStyle: { position: "absolute", right: "0", top: "0" },
        },
        {
          image: "ILO/TCA/TCA_ND_Demo_5_Screen_2.png",
          imageStyle: { position: "absolute", right: "0", top: "0" },
        },
        {
          image: "ILO/TCA/TCA_ND_Demo_5_Screen_3.png",
          imageStyle: { position: "absolute", right: "0", top: "0" },
        },
      ]}
      conversationStyle={{ width: "auto" }}
      pageNumber={"ILO_310"}
    />
  ),
};
